import { RadioForGroup } from '@ui-components/neo.tax';

import { ProjectDisallowance } from '@neo.tax/shared';

import { useRdProjectDisallowancesIds } from './useRdProjectDisallowancesIds';

type RdProjectDisallowanceOption = Omit<RadioForGroup, 'value'> & { value: ProjectDisallowance };
type NoneOfTheAboveOption = Omit<RadioForGroup, 'value'> & { value: 'noneOfTheAbove' };

export const useRdProjectDisallowanceOptions = (): {
  disallowanceOptions: RdProjectDisallowanceOption[];
  noneOfTheAboveOption: NoneOfTheAboveOption;
} => {
  const {
    adaptationForCustomerId,
    internalUseSoftwareId,
    noneOfTheAboveId,
    researchFundedByGrantContractEtcId,
    researchIntoSocialSciencesId,
    researchOutsideUsId,
    reverseEngineeringId,
    surveyOrMarketResearchId,
    testingOrQaInProductionId,
  } = useRdProjectDisallowancesIds();

  return {
    disallowanceOptions: [
      {
        label: 'Testing/QA for project in production',
        value: ProjectDisallowance.TestingOrQaInProduction,
        id: testingOrQaInProductionId,
      },
      {
        label: 'Surveys/market research',
        value: ProjectDisallowance.SurveyOrMarketResearch,
        id: surveyOrMarketResearchId,
      },
      {
        label: 'Research outside US/PR/US territories',
        value: ProjectDisallowance.ResearchOutsideUs,
        id: researchOutsideUsId,
      },
      {
        label: 'Reverse engineering an existing product',
        value: ProjectDisallowance.ReverseEngineering,
        id: reverseEngineeringId,
      },
      {
        label: 'Research funded by grant, contract, other entity',
        value: ProjectDisallowance.ResearchFundedByGrantContractEtc,
        id: researchFundedByGrantContractEtcId,
      },
      {
        label: 'Social science research',
        value: ProjectDisallowance.ResearchIntoSocialSciences,
        id: researchIntoSocialSciencesId,
      },
      {
        label: 'Adaptations for a specific customer',
        value: ProjectDisallowance.AdaptationForCustomer,
        id: adaptationForCustomerId,
      },
      {
        label: 'Internal-use software for back-office function',
        value: ProjectDisallowance.InternalUseSoftware,
        id: internalUseSoftwareId,
      },
    ],
    noneOfTheAboveOption: {
      label: 'None of the above',
      value: 'noneOfTheAbove',
      id: noneOfTheAboveId,
    },
  };
};
